import { useDispatch } from "@/hooks/common/useObserver";
import { __EVENT_FEILD_CHANGE__ } from "@/const/event";

// 为当前字段注册校验器
export const useChange = (state) => {
    const change = () => {
        useDispatch(__EVENT_FEILD_CHANGE__, state);
    };
    return change;
}